import * as z from 'zod'

export const pendingReviewSchema = z.object({
  campsiteName: z.string(),
  campsiteSlug: z.string(),
  prettyId: z.string().optional(),
  token: z.string(),
  // Optional fields when derived from user bookings
  depart: z.string().optional(),
})

export type PendingReview = z.infer<typeof pendingReviewSchema>
export const pendingReviewsSchema = pendingReviewSchema.array()
